import React, { useState, useEffect } from 'react';
import { ExternalLink, Calendar } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const News = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/news/`);
      setPosts(response.data);
    } catch (error) {
      console.error('Failed to fetch news:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section id="news" className="section-container bg-[#0C0E12]">
        <div className="text-center">
          <div className="animate-pulse text-slate-400">Loading news...</div>
        </div>
      </section>
    );
  }

  if (posts.length === 0) {
    return (
      <section id="news" className="section-container bg-[#0C0E12]">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">
            <span className="text-[#32B44A]">$NANA</span> News
          </h2>
          <div className="w-24 h-1 bg-[#FFD600] mx-auto rounded-full" />
          <p className="text-slate-300 max-w-3xl mx-auto text-lg">
            Stay updated with the latest from the $NANA ecosystem
          </p>
        </div>
        <div className="text-center text-slate-400">
          No news posts yet. Check back soon! 🍌
        </div>
      </section>
    );
  }

  return (
    <section
      id="news"
      data-testid="news-section"
      className="section-container bg-[#0C0E12]"
    >
      <div className="text-center space-y-4 mb-16">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">
          <span className="text-[#32B44A]">$NANA</span> News
        </h2>
        <div className="w-24 h-1 bg-[#FFD600] mx-auto rounded-full" />
        <p className="text-slate-300 max-w-3xl mx-auto text-lg">
          Stay updated with the latest from the $NANA ecosystem
        </p>
      </div>

      {/* Timeline */}
      <div className="max-w-4xl mx-auto space-y-8">
        {posts.map((post) => (
          <div
            key={post.id}
            data-testid={`news-post-${post.id}`}
            className="glass rounded-2xl p-6 sm:p-8 card-hover border border-yellow-500/20"
          >
            <div className="flex flex-col md:flex-row gap-6">
              {/* Screenshot */}
              <div className="md:w-2/5 flex-shrink-0">
                <img
                  src={`${API_URL}${post.screenshot_url}`}
                  alt="X Post Screenshot"
                  className="w-full rounded-xl border border-yellow-500/30"
                />
              </div>

              {/* Content */}
              <div className="flex-1 flex flex-col justify-between">
                <div>
                  <div className="flex items-center space-x-2 text-sm text-slate-400 mb-3">
                    <Calendar size={16} />
                    <span>{post.date}</span>
                  </div>
                  
                  <a
                    href={post.x_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center space-x-2 text-[#FFD600] hover:text-[#FFE033] transition-colors font-semibold text-lg"
                  >
                    <span>View on X</span>
                    <ExternalLink size={18} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default News;
